<template>
  <div>
    <!-- 客服 -->
    <div class="service" @click="showServicePopup = true">
      <img :src="require('@/assets/images/service-stick.png')" alt="">
    </div>
    <!-- 弹窗 -->
    <van-popup class="service-popup" v-model="showServicePopup" :close-on-click-overlay="false">
      <div class="service-popup__bd">
        <img src="http://mmcb-pub-static.mmcb.top/service-popup.png" alt="">
      </div>
      <div class="service-popup__close" @click="showServicePopup = false">
        <van-icon name="close" color="#fff" size="36" />
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Service',
  data() {
    return {
      showServicePopup: false
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  .service{
    width: 90px;
    display: block;
    position: fixed;
    right: 0;
    bottom: 120px;
    img{
      width: 100%;
    }
  }
  .service-popup{
    background: none;
    .service-popup__bd{
      img{
        width: 280px;
      }
    }
    .service-popup__close{
      text-align: center;
      margin-top: 15px;
    }
  }
</style>
